import { render, staticRenderFns } from "./DoYouWantToAddAnotherChildInfoModal.vue?vue&type=template&id=bdae3e42&scoped=true&"
import script from "./DoYouWantToAddAnotherChildInfoModal.vue?vue&type=script&lang=js&"
export * from "./DoYouWantToAddAnotherChildInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./DoYouWantToAddAnotherChildInfoModal.vue?vue&type=style&index=0&id=bdae3e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdae3e42",
  null
  
)

export default component.exports